export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    setFormOpen({commit}) {
        commit('setFormOpen');
    },
    setFormClose({commit}) {
        commit('setFormClose');
    },
    setLogOpen({commit}) {
        commit('setLogOpen');
    }
}